import {initFields, typeEvent} from './events-dates';

(($) => {
    'use strict'

    const editEventForm = $('#edit-event-form');
    if(editEventForm.length === 0) {
        return;
    }

    const daterangepickerLocale = {
        format: 'DD/MM/YYYY H:mm',
        cancelLabel: 'Annuler',
        applyLabel: 'Appliquer',
        fromLabel: 'Du',
        toLabel: 'Au',
    };

    // addEventListener for the current occurrence created
    $("i[id^='class-modal-']").on('click', function (e) {
        $('#modal-remove-occurrence').modal('show');
        document.querySelector('#modal-remove-occurrence #remove-occurrence').dataset.id = e.target.dataset.id;
    });

    typeEvent();
    intDateRangePicker();

    $('#add-dates').on('click', function (e) {
        let numberEvent = $('.event_number').length + 1;

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            url: '/admin/events/events/duplicate-occurrence',
            method: 'POST',
            data: {
                iteration: numberEvent
            },
            success: response => {
                $('#duplicate-dates').append(response)

            }
        }).done(function () {
            $('.select2').select2({theme: 'bootstrap4'});

            initFields(numberEvent);

            // addEventListener for the current occurrence created
            $("i[id^='class-modal-']").on('click', function (e) {
                $('#modal-remove-occurrence').modal('show');
                if (e.target.dataset.id === undefined) {
                    document.querySelector('#modal-remove-occurrence #remove-occurrence').dataset.id = e.target.id;
                } else {
                    document.querySelector('#modal-remove-occurrence #remove-occurrence').dataset.id = e.target.dataset.id;
                }
            });

            $('#event_dates_' + numberEvent).daterangepicker({
                opens: 'right',
                timePicker: true,
                showDropdowns: true,
                autoApply: true,
                startDate: moment().startOf('day'),
                endDate: moment().endOf('day'),
                timePicker24Hour: true,
                locale: {
                    format: 'DD/MM/YYYY H:mm'
                },
            }).on('hide.daterangepicker', function (ev, picker) {
                let id = ev.target.dataset.id;
                $('#start_date_event_' + id).val(picker.startDate.format('YYYY-MM-DD H:mm'));
                $('#end_date_event_' + id).val(picker.endDate.format('YYYY-MM-DD H:mm'));
            });

            $('#start_date_event_' + numberEvent).val(moment().startOf('day').format('YYYY-MM-DD H:mm'));
            $('#end_date_event_' + numberEvent).val(moment().endOf('day').format('YYYY-MM-DD H:mm'));

            $('#single-date_' + numberEvent).daterangepicker({
                opens: 'right',
                singleDatePicker: true,
                showDropdowns: true,
                timePicker: true,
                autoApply: true,
                timePicker24Hour: true,
                timePickerIncrement: 15,
                locale: daterangepickerLocale
            }).on('hide.daterangepicker', function (ev, picker) {
                let id = ev.target.dataset.id;
                $('#date_' + id).val(picker.startDate.format('YYYY-MM-DD H:mm'));
            });

            $('#date_' + numberEvent).val(moment().startOf('day').format('YYYY-MM-DD H:mm'));

            typeEvent();
        });
    });

    $('#remove-occurrence').on('click', function (e) {
        if (e.target.dataset.id.includes('class-modal-')) {
            let splitId = e.target.dataset.id.split('-');
            if (splitId[2] !== undefined) {
                // just remove the element occurrence
                $('#duplicate-date_' + splitId[2]).remove();

                $("div[id^='duplicate-date_'] .event_number").each(function (i, e) {
                    var number = i + 2;
                    $(e).attr('id', 'duplicate-date_' + number);
                    $(e).html('#' + number);
                });

                $('#modal-remove-occurrence').modal('hide');
            }

        } else {

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.ajax({
                url: '/admin/events/events/' + e.target.dataset.id + '/destroy',
                method: 'POST',
            }).done(function (response) {
                window.location.replace( '/admin/events/events/' + response.event_id + '/edit' );
            });
        }
    });

    /**
     * Init. the dates range picker
     */
    function intDateRangePicker() {
        $("input[name='daterange[]']").each(function (i, el) {
            publicationDatesRangePicker(i, el);
        });

        $("input[name='single-daterange[]']").each(function (i, el) {
            eventDatesRangePicker(i, el);
        });
    }

    function eventDatesRangePicker(i, el) {
        $(el).daterangepicker({
            opens: 'right',
            autoApply: true,
            showDropdowns: true,
            autoUpdateInput: true,
            singleDatePicker: true,
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 15,
            startDate: new Date($('#date_' + (i + 1)).val()),
            locale: daterangepickerLocale
        }).on('hide.daterangepicker', function (ev, picker) {
            let id = ev.target.dataset.id;
            $('#date_' + id).val(picker.startDate.format('YYYY-MM-DD H:mm'));
        });
    }

    function publicationDatesRangePicker(i, el) {
        $(el).daterangepicker({
            opens: 'right',
            timePicker: true,
            showDropdowns: true,
            autoApply: true,
            startDate: new Date($('#start_date_event_' + (i + 1)).val()),
            endDate: new Date($('#end_date_event_' + (i + 1)).val()),
            timePicker24Hour: true,
            locale: daterangepickerLocale
        }).on('hide.daterangepicker', function (ev, picker) {
            let id = ev.target.dataset.id;
            $('#start_date_event_' + id).val(picker.startDate.format('YYYY-MM-DD H:mm'));
            $('#end_date_event_' + id).val(picker.endDate.format('YYYY-MM-DD H:mm'));
        });
    }

})($);
